import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import DesignerService from "./DesignerService";

const initialState = {
    designers: null,
    designer: null,
    isSuccess: false,
    isLoading: false,
    isError: false,
    errors: false,
    message: null,
}

export const GetAllDesigners = createAsyncThunk(
    "designers/index", async (_, thunkAPI) => {
        try {
            const token = thunkAPI.getState().auth.mainUser.data.token;
            return await DesignerService.GetAllDesigners(token);
        } catch (error) {
            return thunkAPI.rejectWithValue(error?.response?.data?.errors);
        }
    }
)

export const SearchONDesigners = createAsyncThunk(
    "designers/search", async (data, thunkAPI) => {
        try {
            const token = thunkAPI.getState().auth.mainUser.data.token;
            return await DesignerService.SearchONDesigners(data, token);
        } catch (error) {
            let message = error.message;
            return thunkAPI.rejectWithValue(message);
        }
    }
)

export const CreateNewDesigner = createAsyncThunk(
    "designer/create", async (data, thunkAPI) => {
        try {
            const token = thunkAPI.getState().auth.mainUser.data.token;
            return await DesignerService.CreateNewDesigner(data, token);
        } catch (error) {
            return thunkAPI.rejectWithValue(error?.response?.data?.errors);
        }
    }
)

export const GetSingleDesigner = createAsyncThunk(
    "designer/show", async (id, thunkAPI) => {
        try {
            const token = thunkAPI.getState().auth.mainUser.data.token;
            return await DesignerService.GetSingleDesigner(id, token);
        } catch (error) {
            return thunkAPI.rejectWithValue(error?.response?.data?.errors);
        }
    }
)

export const UpdateDesignerData = createAsyncThunk(
    "designer/update", async (data, thunkAPI) => {
        try {
            const token = thunkAPI.getState().auth.mainUser.data.token;
            return await DesignerService.UpdateDesignerData(data, token);
        } catch (error) {
            return thunkAPI.rejectWithValue(error?.response?.data?.errors);
        }
    }
)

export const DeleteDesignerAction = createAsyncThunk(
    "designer/delete", async (id, thunkAPI) => {
        try {
            const token = thunkAPI.getState().auth.mainUser.data.token;
            return await DesignerService.DeleteDesignerAction(id, token);
        } catch (error) {
            return thunkAPI.rejectWithValue(error?.response?.data?.errors);
        }
    }
)

const DesignerSlice = createSlice({
    name: "designers",
    initialState,
    reducers: {
        designersReset: (state) => {
            state.isSuccess = false;
            state.isLoading = false;
            state.isError = false;
            state.errors = false;
            state.message = null;
        }
    },
    extraReducers: {
        [GetAllDesigners.pending]: (state) => {
            state.isLoading = true;
        },
        [GetAllDesigners.fulfilled]: (state, action) => {
            state.isLoading = false;
            state.designers = action.payload;
        },
        [GetAllDesigners.rejected]: (state, action) => {
            state.isLoading = false;
            state.isError = true;
            state.message = action.payload;
            state.errors = action.payload;
        },

        // Search On Designers 
        [SearchONDesigners.pending]: (state) => {
            state.isLoading = true;
        },
        [SearchONDesigners.fulfilled]: (state, action) => {
            state.isLoading = false;
            state.designers = action.payload;
            state.isSuccess = true;
        },
        [SearchONDesigners.rejected]: (state, action) => {
            state.isLoading = false;
            state.isError = true;
            state.message = action.payload;
        },

        // SHOW Designer
        [GetSingleDesigner.pending]: (state) => {
            state.isLoading = true;
        },
        [GetSingleDesigner.fulfilled]: (state, action) => {
            state.isLoading = false;
            state.isSuccess = false
            state.designer = action.payload
        },
        [GetSingleDesigner.rejected]: (state, action) => {
            state.isLoading = false;
            state.isError = true;
        },

        // Create New Designer
        [CreateNewDesigner.pending]: (state) => {
            state.isLoading = true;
        },
        [CreateNewDesigner.fulfilled]: (state, action) => {
            state.isLoading = false;
            state.isSuccess = true;
        },
        [CreateNewDesigner.rejected]: (state, action) => {
            state.isLoading = false;
            state.isError = true;
            state.errors = action.payload
        },

        // Update Designer Data
        [UpdateDesignerData.pending]: (state) => {
            state.isLoading = true;
        },
        [UpdateDesignerData.fulfilled]: (state, action) => {
            state.isLoading = false;
            state.isSuccess = true;
        },
        [UpdateDesignerData.rejected]: (state, action) => {
            state.isLoading = false;
            state.isError = true;
            state.errors = action.payload
        },

        // Delete Designer Data
        [DeleteDesignerAction.pending]: (state) => {
            state.isLoading = true;
        },
        [DeleteDesignerAction.fulfilled]: (state, action) => {
            state.isLoading = false;
            state.isSuccess = true;
        },
        [DeleteDesignerAction.rejected]: (state, action) => {
            state.isLoading = false;
            state.isError = true;
            state.errors = action.payload
        },
    }
})

export const { designersReset } = DesignerSlice.actions

export default DesignerSlice.reducer